<template>
  <div>

    <div class="floatrught" :style="{height:clubRoundId?'400px':'300px'}">
      <div class="btnicon" @click="open=!open">
        <img v-if="open" src="../assets/images/pendant_icon_putaway.svg" alt="">
        <img v-else src="../assets/images/pendant_icon_open.svg" alt="">
      </div>
      <div v-if="open">
        <div v-if="clubRoundId" class="fletxhi" @click="jump(`/clubRound/${clubRoundId}`,3) " @mouseleave="fouces" @mousemove="fouces_2(4)">
          <div>
            <img v-show="index!=4" style="width:33px;height:31px" src="../assets/images/match_pendant_leaguematch_bule.svg"/>
            <img style="width:33px;height:31px" v-show="index==4" src="../assets/images/match_pendant_leaguematch_white.svg"/>
          </div>
          <div style="margin-top:2px">公棚联赛</div>
        </div>
        <div class="fletxhi" @click="jumpIndex('/?index=1',1) " @mouseleave="fouces" @mousemove="fouces_2(1)">
          <div  class="fletxhiIcon">
            <img v-show="index!=1" style="width:33px;height:31px" src="../assets/images/live_ic_blue.svg"/>
            <img style="width:33px;height:31px" v-show="index==1" src="../assets/images/live_ic1_white.svg"/>
          </div>
          <div style="margin-top:2px">赛事直播</div>
        </div>
        <!-- <div class="fletxhi" @click="jumpIndex('/footsearch?index=6',6)" @mouseleave="fouces" @mousemove="fouces_2(2)">
          <div  class="fletxhiIcon"><img v-show="index!=2" style="width:33px;height:32px" src="../assets/images/live_ic2_blue.svg"/>
            <img v-show="index==2" style="width:33px;height:32px" src="../assets/images/live_ic2_white.svg"/></div>
          <div style="margin-top:2px">足环查询</div>
        </div> -->
        <div class="fletxhi" @click="jumpIndex('/sunrise',2)" @mouseleave="fouces" @mousemove="fouces_2(4)">
          <div  class="fletxhiIcon"><img v-show="index!=4" style="width:33px;height:32px" src="../assets/images/live_ic4_blue.svg"/>
            <img v-show="index==4" style="width:33px;height:32px" src="../assets/images/live_ic4_white.svg"/></div>
          <div style="margin-top:2px">日出日落</div>
        </div>
        <div class="fletxhi" @click="jumpIndex('/contect?index=2',2)" @mouseleave="fouces" @mousemove="fouces_2(3)">
          <div  class="fletxhiIcon"><img v-show="index!=3" style="width:33px;height:32px" src="../assets/images/live_ic3_blue.svg"/>
            <img v-show="index==3" style="width:33px;height:32px" src="../assets/images/live_ic3_white.svg"/></div>
          <div style="margin-top:2px">联系我们</div>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import store from '@/store'
import {getClubId} from '@/api/search'
export default {
  data () {
    return {
      index: 0,
      clubRoundId:null,
      open:false
    }
  },
  mounted() {
      // setTimeout(()=>{
      //   if(this.$route.query.matchid){
      //     this.getClub()
      //   }
      // },1000)
      
    
  },
  methods: {
    jumpIndex (path) {
       const domain = process.env.NODE_ENV === 'production'
          ? 'https://live.sigoran.com/#'
          : process.env.NODE_ENV === 'test'
          ?'https://test-live.sigoran.com/#'
          :"https://test-live.sigoran.com/#"
        window.open(`${domain}${path}`, '_blank')
    },
    async getClub(){
     const res = await getClubId({roundId:this.$route.query.matchid})
     console.log('res',res)
     if(res.data&&res.data.clubRoundId){
      this.clubRoundId=res.data.clubRoundId
     }
    },
    fouces () {
      this.index = 0
    },
    fouces_2 (index) {
      this.index = index
    },
    jump (path, index) {
      store.commit('changindex', index)
      // this.$router.push({
      //   path: path
      // })
      let routeData = this.$router.resolve({
          path:path
      });
      window.open(routeData.href, '_blank');

    }
  }
}
</script>
<style>
  .fletxhiIcon{
  display: flex;
    align-items: center;
    justify-content: center;
}
.btnicon{
  width: 40px;
  height: 80px;
position:absolute;
top:50%;
left: -40px;
box-shadow: -2px 0px 2px 0px #e7eaf1;

background: #ffffff;
border-radius: 6px 0px 0px 6px;
margin-top: -40px;
display: flex;
align-items: center;
justify-content: center;
}
  .floatrught {
    cursor: pointer;
    /* width: 100px; */

    background: #ffffff;
    position: fixed;
    right: 0px;
    top: calc(50vh - 149px);
    /* box-shadow: 0px 0px 9px 0px rgba(43, 124, 247, 0.34); */
    box-shadow: -2px 0px 12px 0px #E7EAF1;
    display: flex;
    flex-direction: column;
    z-index: 999;
    /* position: relative; */
  }

  .fletxhi {
    width: 100px;
    text-align: center;
    padding-top: 18px;
    font-size: 18px;
    padding-bottom: 17px;
    border-bottom: 1px solid #EEF1F6;
    line-height: 25px;
    color: #2556C4;

  }

  .fletxhi:hover {
    background: #2556C4;;
    color: #ffffff;
    
  }

  .fletxhi:nth-child(3) {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/RightNav.vue